import React from 'react';
import Linkify from '../../../../core/components/Linkify';
const Text = ({ data }) => {
    return React.createElement(Linkify, null, data.text);
};
export default Text;
//# sourceMappingURL=Text.js.map